import React, { useCallback } from 'react'
import { Grid, Form } from 'semantic-ui-react'
import { FormTitle } from '../../../commonComponents/FormTitle'
import ValueBuildUpList from './ValueBuildUpList'
import { useDispatch, useSelector } from 'react-redux'
import List from '../../../commonComponents/List'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { useDocument } from '../../hooks/useDocument'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import InputField from '../../../commonComponents/formComponents/inputField'
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow';


function ValueBuildUpTab(props) {
  const { isLoading, AddItem, deleteItem, updateItem, saveItem } = useDocument({
    actionType: 'VALUE_BUILD_UP',
    tableName: 'valueBuildUpList',
    containerKey: 'valueBuildUp',
  })

  const valueBuildUpList = useSelector((state) => state.valueBuildUpReducer.valueBuildUpList) || []
  const { incoterms } = useSelector((state) => state.Shipment.transportation.deliveryTerms)
  const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.valueBuildUpTab) || []



  const shipId = window.shipId

  const isFormEnabled = false
  const dispatch = useDispatch()

  const renderItem = useCallback(
    (item) => {
      return (
        <ValueBuildUpList
          key={item.id}
          item={item}
          isFormEnabled={isFormEnabled}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
        />
      )
    },
    [isFormEnabled, updateItem, deleteItem, AddItem, saveItem]
  )

  return (
    <>
      <Form.Group className='float-container '>
      {ErrorWarningsList?.length > 0 && !props.disabled && valueBuildUpList?.length>0 && (
            <ErrorMessagesWindow errors={ErrorWarningsList} />
          )}
        <FormTitle boxNumber='4/9' title='ADDITIONS AND DEDUCTIONS'></FormTitle>
        <Grid>
          <Grid.Row>
            <Grid.Column
              width='15'
              className='divFormFeild border-bottom b-brr-5 b-trr-5 b-blr-5 b-tlr-5'
            >
              <InputField
                id={`incoterms`}
                isLabel={false}
                type='text'
                value={incoterms}
                label='incoterms'
                className={'field-bg'}
                clearInput={false}
                disabled={true}
              />
            </Grid.Column>
            <Grid.Column width='1'>

            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div style={{ marginTop: '45px' }}>
          <List renderItem={renderItem} dataSource={valueBuildUpList} />
        </div>
        {isLoading && <CustomLoader />}

        {valueBuildUpList?.length < 9 && (
          <AddBtn id="addTypeCurrencyValue" disabled={(isFormEnabled || isLoading)} onClick={() => AddItem()} text='Add'></AddBtn>
        )}
      </Form.Group>
    </>
  )
}

export default ValueBuildUpTab;
